import { CustomerFlowType } from '../../constants/customer-flow-type';
import { ResolverError } from '../../constants/resolver-error';
import {
  AccommodationAddressInput,
  Application,
  BillingAddressInput,
  Customer,
  CustomerEligibility,
  CustomerSearchErrors,
  CustomerSearchInput,
} from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import { NetworkError } from '../../state-machine/actions/genericActions';
import { track } from '../../state-machine/actions/segment';
import { BasicInfoContinuedModel, BasicInfoModel } from '../../state-machine/types/ecommMachine.types';
import { CustomerSearchRequestMachineContext } from '../../state-machine/types/shared/context/customerSearchMachineContext';
import { PayFrequencyModel } from '../employment/updateEmployment';
import { queryCustomers } from './queryCustomers';

export type CustomerSearchResult = {
  accommodationAddress?: AccommodationAddressInput;
  application?: Application;
  basicInfo?: BasicInfoModel;
  basicInfoContinued?: BasicInfoContinuedModel;
  billingAddress?: BillingAddressInput;
  payFrequency?: PayFrequencyModel;
  customerFlowType?: CustomerFlowType;
  customers?: Customer[];
  customerSearchErrors?: CustomerSearchErrors[];
  eligibilityDetails?: CustomerEligibility;
  resolverErrors?: ResolverError[];
  optedIntoSmsMarketing?: boolean;
};

// if taxIdLast4 is passed in the event.data?.taxIdLast4, this function will use it
const queryCustomersByCellphone = async (context: CustomerSearchRequestMachineContext): Promise<CustomerSearchResult> => {
  try {
    const customerCheckPayload: CustomerSearchInput = {
      cellPhone: context.cellPhone,
      orderId: context.orderId,
    };

    const result = await queryCustomers(context, customerCheckPayload);
    track('Phone Number Matched', { numRecords: result.customers?.length });
    return result;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};
export default queryCustomersByCellphone;
